import axios from "axios";

export const state = {
    studentrollcalls: [],
};

export const getters = {
    studentrollcalls: state => state.studentrollcalls,
};

export const mutations = {
    setStudentrollcalls(state, newValue) {
        state.studentrollcalls = newValue
    },
};

export const actions = {
    fetchStudentRollcalls({ commit }) {
        axios.get('/studentrollcalls').then(res => {
            commit('setStudentrollcalls', res.data.studentrollcalls);
        })
    },
    filterStudentRollcall({commit}, {schoolterm,year}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        let url = "/filterstudentrollcalls";
        axios.post(url, formData).then((response) => {
            commit('setStudentrollcalls', response.data.studentrollcalls)
        })
    },
};
